import { styled } from 'styled-components'
import { Block, TextInput } from 'suomifi-ui-components'

export const PersonSelectionWrapper = styled(Block)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m};
  margin-top: ${({ theme }) => theme.spacing.m};
  margin-bottom: ${({ theme }) => theme.spacing.m};
`

export const ContentSelectionWrapper = styled(Block)`
  margin-top: ${({ theme }) => theme.spacing.m};
  margin-bottom: ${({ theme }) => theme.spacing.m};
`

export const PreviousAddressesPeriodTextInput = styled(TextInput)`
  margin-left: ${({ theme }) => theme.spacing.l};
  margin-bottom: ${({ theme }) => theme.spacing.xs};
  &&& label {
    ${({ theme }) => theme.typography.bodyTextSmall}
  }
` as typeof TextInput // https://github.com/styled-components/styled-components/issues/1803
